export const DEVICE_API_ERRORS = {
	'There is no available license for extension mirroring': '2',
};
